var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { ViewBreakpoint } from '../../models/view-breakpoint.enum';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { takeUntil, filter } from 'rxjs/operators';
import { AnimationService } from 'src/app/engine/animation.service';
import { ViewService } from '../../view.service';
import { LayoutService } from '../../layout.service';
import { ViewLayout } from '../../models/view-layout.enum';
export class ViewNavbarComponent {
    // ---------- Lifecycle Events ----------
    constructor(animationService, viewService, changeDetectorRef, layoutService) {
        this.animationService = animationService;
        this.viewService = viewService;
        this.changeDetectorRef = changeDetectorRef;
        this.layoutService = layoutService;
        // ---------- Class Variables ----------
        this.viewBreakpoint = ViewBreakpoint;
        this.isAnimated = false;
        this.isPaginated = false;
        this.showScrubber = false;
        this.ngUnsubscribe = new Subject();
        this.viewLayout = ViewLayout;
        this.nextChapterLabel = '';
        this.previousChapterLabel = '';
    }
    ngOnInit() {
        this.chapter$.pipe(filter(chapter => chapter != null), takeUntil(this.ngUnsubscribe)).subscribe(chapter => {
            this.isAnimated = this.animationService.isChapterAnimated(chapter);
            this.changeDetectorRef.markForCheck();
        });
        this.chapterCount$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(count => {
            this.isPaginated = count > 1;
            this.changeDetectorRef.markForCheck();
        });
        this.breakpoint$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(breakpoint => {
            this.showScrubber = breakpoint !== ViewBreakpoint.Small;
            this.changeDetectorRef.markForCheck();
        });
        combineLatest(this.chapterIndex$, this.chapterCount$).pipe(takeUntil(this.ngUnsubscribe)).subscribe(([index, count]) => {
            const previous = index > 0 ? index : 1;
            const next = index + 2 > count ? count : index + 2;
            this.nextChapterLabel = `Next Chapter (${next} of ${count})`;
            this.previousChapterLabel = `Previous Chapter (${previous} of ${count})`;
            this.changeDetectorRef.markForCheck();
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    // ---------- Interactions ----------
    handleNextChapter() {
        this.viewService.nextChapter();
    }
    handlePreviousChapter() {
        this.viewService.previousChapter();
    }
    isVisible(layout) {
        return this.layoutService.isLayoutVisible(layout);
    }
}
__decorate([
    Select(ViewState.getBreakpoint),
    __metadata("design:type", Observable)
], ViewNavbarComponent.prototype, "breakpoint$", void 0);
__decorate([
    Select(StoryChaptersState.getSelectedChapter),
    __metadata("design:type", Observable)
], ViewNavbarComponent.prototype, "chapter$", void 0);
__decorate([
    Select(StoryChaptersState.getSelectedChapterIndex),
    __metadata("design:type", Observable)
], ViewNavbarComponent.prototype, "chapterIndex$", void 0);
__decorate([
    Select(StoryChaptersState.getChapterCount),
    __metadata("design:type", Observable)
], ViewNavbarComponent.prototype, "chapterCount$", void 0);
